import React, { memo } from 'react';
import Svg, { Path } from 'react-native-svg';

export const IconArrowUp = memo(({ color = '#545454', size = 24, ...rest }) => {
  return (
    <Svg width={size} height={size} viewBox="0 0 24 24" {...rest}>
      <Path
        fill={color}
        fillRule="nonzero"
        d="M7.125 15.705l4.58-4.58 4.59 4.58 1.41-1.41-6-6-6 6z"
      />
    </Svg>
  );
});
